var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"truncate inline-block chip-link",attrs:{"link":"","label":"","small":"","href":_vm.url,"target":"_blank","title":_vm.url}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }